export const API_OPTIONS = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjOTllNWQ2YmFjZWVhN2M0MTcwMzg5MzFlZTg2YjNiZSIsIm5iZiI6MTcyMDI1MTkzNC43MTEzMjIsInN1YiI6IjY2ODhmM2YyNWRkZDE1YWM2YzFkMTU4MyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.si7iM9KV3lTDX9KvajFelqK2XEbK4As4f21oGsQM-j8",
  },
};

export const mainLogo = "https://img.icons8.com/ios/50/apple-tv.png";

export const bgImg =
  "https://assets.nflxext.com/ffe/siteui/vlv3/594f8025-139a-4a35-b58d-4ecf8fdc507c/d3c4e455-f0bf-4003-b7cd-511dda6da82a/IN-en-20240108-popsignuptwoweeks-perspective_alpha_website_large.jpg";

export const userAvatar =
  "https://netflix-bootcamp-db.netlify.app/static/media/profileIcon1.b36331ae.jpg";

export const cardImgURL = "https://image.tmdb.org/t/p/w780/";
